module.exports = __webpack_public_path__ + "page-infinie-rubik-gif.gif?9f45774a6a412c828d405e3553e2b217";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page-infinie-rubik-gif.gif
// module id = 78
// module chunks = 0